export const usersApiPaths = {
    isWorkflowPayer: 'users/me/is-workflow-payer',
    security: 'users/me/security',
} as const;
